export default __webpack_public_path__ + "static/media/2 Kattlas Vellikada.f68b6b92.jpg";